export class TicketUnreadAdmin {
	id:number;
	adminId:number;
	ticketId:number;

	constructor(data:any) {
		this.id = data.id;
		this.adminId = data.adminId;
		this.ticketId = data.ticketId;
	}
}